/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  InvitesControllerInviteResendV1200,
  InvitesControllerInviteResendV1PathParameters,
  InvitesControllerInviteUserV1201,
  UserInviteDTO,
} from '../models';

@Injectable({ providedIn: 'root' })
export class InvitesService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Invite a new user
   */

  inviteUser<TData = InvitesControllerInviteUserV1201>(userInviteDTO: UserInviteDTO): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/invites`, userInviteDTO);
  }
  /**
   * @summary Resend an invitation email
   */

  inviteResend<TData = InvitesControllerInviteResendV1200>({ email }: InvitesControllerInviteResendV1PathParameters): Observable<TData> {
    return this.http.post<TData>(`/clients/v1/invites/${email}/resend`, undefined);
  }
}
